import { render, staticRenderFns } from "./mailing_editor.vue?vue&type=template&id=64036862&"
import script from "./mailing_editor.vue?vue&type=script&lang=js&"
export * from "./mailing_editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64036862')) {
      api.createRecord('64036862', component.options)
    } else {
      api.reload('64036862', component.options)
    }
    module.hot.accept("./mailing_editor.vue?vue&type=template&id=64036862&", function () {
      api.rerender('64036862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/mailings/mailing_editor.vue"
export default component.exports